export const colors = {
    black: "black",
    white: "hsl(0, 0%, 100%)",
    greyLightest: "hsl(0, 0%, 98%)",
    greyLighter: "hsl(0, 0%, 96%)",
    greyLight: "hsl(0, 0%, 93%)",
    greyDark: "hsl(0, 1%, 16%)",
    greyMedium: "hsl(0, 0%, 35%)",
    greyMain: "hsl(0, 0%, 72%)",
    greyMainLight: "hsl(0, 0%, 86%)",
    rtGreenDark: "hsl(165, 46%, 52%)",
    rtGreenMain: "hsl(165, 57%, 65%)",
    rtGreenLight: "hsl(165, 58%, 75%)",
    rtGreenLighter: "hsl(165, 75%, 91%)",
    greenDark: "hsl(135, 45%, 36%)",
    greenMain: "hsl(111, 43%, 58%)",
    greenLight: "hsl(111, 55%, 81%)",
    greenLighter: "hsl(137, 50%, 93%)",
    blueDark: "hsl(207, 66%, 40%)",
    blueMain: "hsl(207, 66%, 55%)",
    blueLight: "hsl(207, 83%, 80%)",
    blueLighter: "hsl(188, 60%, 95%)",
    redDark: "hsl(358, 67%, 45%)",
    redMain: "hsl(358, 84%, 62%)",
    redLight: "hsl(357, 100%, 85%)",
    redLighter: "hsl(0, 76%, 95%)",
    yellowDark: "hsl(27, 100%, 48%)",
    yellowMain: "hsl(42, 100%, 67%)",
    yellowLight: "hsl(41, 100%, 84%)",
    yellowLighter: "hsl(53, 100%, 93%)",
    orangeDark: "hsl(14, 89%, 65%)",
    orangeMain: "hsl(14, 100%, 76%)",
    orangeLight: "hsl(14, 95%, 83%)",
    orangeLighter: "hsl(14, 100%, 91%)",
    lavenderDark: "hsl(224, 56%, 63%)",
    lavenderMain: "hsl(224, 65%, 73%)",
    lavenderLight: "hsl(224, 58%, 81%)",
    lavenderLighter: "hsl(225, 67%, 88%)",
    violetDark: "hsl(261, 53%, 55%)",
    violetMain: "hsl(260, 61%, 68%)",
    violetLight: "hsl(261, 72%, 79%)",
    violetLighter: "hsl(260, 78%, 87%)",
};
//# sourceMappingURL=theme.js.map